import { Headers, PostRequest } from "../../utils/ApiServices";

export const updateProfile = async (data, token, file) => {
  return await PostRequest(
    "update/profile",
    { picture: file, user: data, token: token },
    Headers.mutipart
  );
};
